import Section from './Section';
import {useNavigate} from 'react-router-dom';

const BackLink = ({text, path}) => {

    let navigate = useNavigate();

    return (
        <div className="full-width blue-bg">
                <Section extraClasses="no-banner with-padding">
                    <button className='back-button' onClick={() => navigate(path)}><label>{text}</label></button>
                </Section>    
            </div>
    );
}

export default BackLink;